import React, { useCallback, Fragment, useContext } from 'react';

import { BindActionType } from 'app/model/Bind';
import { LocalizationContext } from 'app/localization/Context';

import { ReactComponent as IconX } from 'images/general/x.svg';
import { ReactComponent as IconBack } from 'images/general/back.svg';

import { ReactComponent as IconDevices } from 'images/bind/element/devices.svg';
import { ReactComponent as IconAlarm } from 'images/bind/element/alarm.svg';
import { ReactComponent as IconCall } from 'images/bind/element/call.svg';
import { ReactComponent as IconScenario } from 'images/bind/scenarios.svg';
import { ReactComponent as IconEmail } from 'images/bind/element/email.svg';
import { ReactComponent as IconNotif } from 'images/bind/element/notif.svg';
import { ReactComponent as IconSms } from 'images/bind/element/sms.svg';
import { createBindNotifInfoObject } from 'app/model/BindData';

export default function SelectEventType({
    negotiatedProtocol,
    preBind, dismissHandler,
    pageData, setPageData, pushState, back,
}) {
    const l = useContext(LocalizationContext);
    const s = l.strings;
    const b = s.createBindProcess;

    const deviceClick = useCallback(() => {
        setPageData({ name: 'select-device', stage: pageData.stage });
    }, [setPageData, pageData]);

    const scenarioClick = useCallback(() => {
        setPageData({ name: 'select-scenario', stage: pageData.stage });
    }, [setPageData, pageData]);

    const alarmClick = useCallback(() => {
        setPageData({ name: 'special-type', eventType: 'alarm', stage: pageData.stage });
    }, [setPageData, pageData]);

    const smsClick = useCallback(() => {
        setPageData({ name: 'special-type', eventType: 'sms', stage: pageData.stage });
    }, [setPageData, pageData]);

    const emailClick = useCallback(() => {
        setPageData({ name: 'special-type', eventType: 'email', stage: pageData.stage });
    }, [setPageData, pageData]);

    const callClick = useCallback(() => {
        setPageData({ name: 'special-type', eventType: 'call', stage: pageData.stage });
    }, [setPageData, pageData]);

    const notifClick = useCallback(() => {
        const _preBind = { ...preBind };
        let _actionInfos = [..._preBind.actionInfos];
        _actionInfos = _actionInfos.filter(info =>
            (info.data.action_type !== BindActionType.notiftcation)
        );
        _actionInfos.push(createBindNotifInfoObject(l));
        _preBind.actionInfos = _actionInfos;
        pushState({preBind: _preBind, pageData: { name: 'main' }})
    }, [preBind, pushState, l]);

    return (
        <div className="create-bind-page-content">
            <IconBack className="nav-icon" /> <div className="nav-button" onClick={() => { back(); }} />
            <IconX className="nav-icon-secondary" /> <div className="nav-button-secondary" onClick={dismissHandler} />


            {pageData.stage === 'if' && (
                <Fragment>
                    <div className="header">{b.if}</div>
                    <div className="info">{b.selectIfEventType}</div>

                    <div className="stage-card" onClick={deviceClick}>
                        <IconDevices className="icon" />
                        <div className="title">{b.device}</div>
                        <IconBack className="action-icon" />
                    </div>

                    <div className="stage-card" onClick={alarmClick}>
                        <IconAlarm className="icon" />
                        <div className="title">{b.time}</div>
                        <IconBack className="action-icon" />
                    </div>
                </Fragment>
            )}

            {pageData.stage === 'then' && (
                <Fragment>
                    <div className="header">{b.then}</div>
                    <div className="info">{b.selectStatementType}</div>

                    <div className="stage-card" onClick={deviceClick}>
                        <IconDevices className="icon" />
                        <div className="title">{b.device}</div>
                        <IconBack className="action-icon" />
                    </div>

                    {negotiatedProtocol.hasScenarioInBind ?
                        <div className="stage-card" onClick={scenarioClick}>
                            <IconScenario className="icon" />
                            <div className="title">{b.scenario}</div>
                            <IconBack className="action-icon" />
                        </div> : null}

                    {negotiatedProtocol.supportCallInBind ? <div className="stage-card" onClick={callClick}>
                        <IconCall className="icon" />
                        <div className="title">{b.call}</div>
                        <IconBack className="action-icon" />
                    </div> : null}

                    <div className="stage-card" onClick={notifClick}>
                        <IconNotif className="icon" />
                        <div className="title">{b.notify}</div>
                        <IconBack className="action-icon" />
                    </div>

                    {negotiatedProtocol.supportEmailInBind ? <div className="stage-card" onClick={emailClick}>
                        <IconEmail className="icon" />
                        <div className="title">{b.email}</div>
                        <IconBack className="action-icon" />
                    </div> : null}

                    {negotiatedProtocol.supportSMSInBind ? <div className="stage-card" onClick={smsClick}>
                        <IconSms className="icon" />
                        <div className="title">{b.sms}</div>
                        <IconBack className="action-icon" />
                    </div> : null}
                </Fragment>
            )}
        </div>
    );
}
